module.exports = __webpack_public_path__ + "images/emoji/railway_car.25035642f12212c2af98.png";